import { HelmetDexteel } from "@dexteel/mesf-core";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { CatalogAdjustmentReason } from "../../models/CatalogAdjustmentReason";
import { getAdjustmentReasons } from "../../repositories/CatalogAdjustmentReasonRepository";
import { TableAdjustmentReason } from "./components/TableAdjustmentReason";

export const reasonUrl = "/configuration/adjustments-reasons/";

export const useAdjustmentReasons = (onError?: (error: Error) => void) => {
	return useQuery<CatalogAdjustmentReason[], Error>({
		queryKey: ["adjustmentReasons"],
		queryFn: ({ signal }) => getAdjustmentReasons({}, signal),
		onError: onError,
	});
};

export const CatalogAdjustmentReasonPage = () => {
	const { reasonId } = useParams();

	return (
		<>
			<HelmetDexteel title="Adjustment Reasons" />
			<TableAdjustmentReason reasonId={reasonId} />
		</>
	);
};
